import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavigationBorder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 414,
	height: 13,
	viewBox: "0 0 414 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 12,
			width: 165.5,
			height: 1,
			fill: "#DFCBF5",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M194.925 1H219.075C226.385 1 233.046 3.76683 238.053 8.30423C240.97 10.9473 244.553 13 248.5 13H165.5C169.447 13 173.03 10.9473 175.947 8.30423C180.954 3.76683 187.615 1 194.925 1Z",
			fill: "#0D081C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M248.5 13V12C244.903 12 241.551 10.1246 238.724 7.5632C233.54 2.86514 226.642 0 219.075 0H194.925C187.358 0 180.46 2.86511 175.276 7.5632C172.449 10.1246 169.097 12 165.5 12V13C167.178 13 168.789 12.6292 170.312 12C172.372 11.1486 174.27 9.82404 175.947 8.30423C180.954 3.76685 187.615 1 194.925 1H219.075C226.385 1 233.046 3.76685 238.053 8.30423C239.73 9.82404 241.628 11.1486 243.688 12C245.211 12.6292 246.822 13 248.5 13Z",
			fill: "#DFCBF5",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 248.5,
			y: 12,
			width: 165.5,
			height: 1,
			fill: "#DFCBF5",
			fillOpacity: .1
		})
	]
});
export default SvgNavigationBorder;
